import styled from "@emotion/styled";
import type { PropsWithChildren, ReactNode } from "react";

import { PropertiesPanelPopoverControl, type RenderContentProps } from "@skilitics/designer-ui-components";

import { EventConditionChip } from "./EventConditionChip.tsx";

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 236px;

  padding: 3px;
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  width: 100%;

  padding: 3px 5px;
  margin-block-end: 10px;

  color: ${({ theme }) => theme.generalTextIcon};
  background-color: ${({ theme }) => theme.primaryContainer};

  border: 1px solid ${({ theme }) => theme.primaryContainerOutline};
  border-radius: 5px;
`;

type Props = {
  title: string;
  icon: ReactNode;
  description: ReactNode;
  heading?: ReactNode;
};

export const EventConditionEditor = ({ title, icon, description, heading, children }: PropsWithChildren<Props>) => {
  const renderContent: RenderContentProps = ({ open }) => {
    return <EventConditionChip title={title} open={open} />;
  };

  return (
    <PropertiesPanelPopoverControl popoverHeader={heading} renderContent={renderContent} id="trigger-event-popover">
      <Container>
        {description && (
          <InfoContainer>
            {icon}
            {description}
          </InfoContainer>
        )}
        {children}
      </Container>
    </PropertiesPanelPopoverControl>
  );
};
